import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import Infographic from "../../components/protect-infographic"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"



var image
var content = {
  hero: {
    title: (
      <span>
       Protect Your Organization<br/>

with Project Ares Cyber Training
      </span>
    ),
    text:<span>
 <h4 style={{margin:"0 0 .5em 0"}}>Do you have gaps in cyber readiness?
 </h4>

 <h4 style={{margin:"0 0 .5em 0"}}>Is your organization really ready to handle the next cyber-attack?
</h4>

<h4 style={{margin:"0 0 .5em 0"}}>Are you concerned about cyber risk mitigation, monitoring, and incident response</h4>
<p>Well-trained frontline defenders can ease cyber preparedness worries.</p>
<p>Project Ares is an award-winning online cyber security training platform suitable for any business looking to persistently harden its posture with a people-first approach. We can help you:</p>
<ul>
  <li>Hire the best talent </li>
  <li>Train in realistic scenarios </li>
  <li>Boost team morale  </li>
  </ul> 
   </span>   },

  calendly: {
    text:  <span>We'd love to learn about your business or institution.<br/>  Schedule a consultation with us now.</span>,
  },

  cta1: {
    title: "Upskill Cyber Teams With Hands-On Scenario Training",
    text:<span> <span>White Paper - </span>Gamified learning and artificial intelligence.</span>,
    url:
      "https://marketing.circadence.com/acton/media/36273/upskill-cyber-teams-with-artificial-intelligence-and-gamified-learning-whitepaper",
    cta: "Download Now",
  },

  
  
  cta2: {
    title: "Invest in your team. ",
    text:
      "Learn more about Project Ares to keep the cyber skills sharp in your organization.",
    url:
      "/project-ares",
    cta: "Learn More",
  },
  social: {
    social1: {
      image: "",
      title: "",
      text:
        "Social Proof to be determined ",
      url: "/teach",
    },
  },
  //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  industries: {
   industry1: {
      title: "Talent Acquisition",
      text:
        "",
      url:
        "/protect/cyber-training-talent-recruitment-assessment",
    },
    industry2: {
      title: "Financial Services ",
      text:
        "",
      url: "/protect/cyber-training-financial-services",
    },
    industry3: {
      title: "Technology",
      text:
        "",
      url:
        "/protect/cyber-training-technology",
    },
    industry4: {
      title: "Government",
      text:
        "",
      url:
        "/protect/cyber-training-government",
    },
  },
  resources: {
    resource1: {
      title: <span>Gamification for Cyber Professional Development <span>Fact Sheet</span></span>,
      text:
        "Learn why gamified learning can support skills training and acquisition for today’s cyber security professionals.",
      url:
        "https://marketing.circadence.com/acton/attachment/36273/f-1ebf399b-baed-420b-a651-3156c6cf248c/1/-/-/-/-/Gamification%20Fact%20Sheet%20%28links%20to%20gamification%20blog%20post%29.pdf",
    },
    resource2: {
      title:<span>Involta Improves Cyber Team Training with Project Ares <span>Success Story</span></span>,
      text:
        "Read how this MSSP helped their cyber team train continuously to stay on top of the latest threats.  ",
      url: "https://staging.circadence.com/wp-content/uploads/2020/03/New-Involta-Case-Study-FINAL.pdf",
    },
    resource3: {
      title:<span>Strengthen Your Security Reputation  <span>E-Book</span> </span>,
      text:
        "Tips and advice for cyber leaders to protect their profession and career reputation with strategic cyber training options. ",
      url:
        "https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00e0/t/page/fm/0",
    },
    
  },
  simple: {
    simple1: {
      text: <span><strong>Empower cyber security teams</strong> with realistic training environments.</span>,
    },
    simple2: {
      text: <span><strong>Gain hands-on skills</strong> in specialized work roles aligned to NIST/NICE Cybersecurity Workforce Framework.</span>,
    },
    simple3: {
      text:<span><strong>Learn the latest tools, tactics, and procedures</strong>  on common emulated virtual networks.</span>,
        
    },
    simple4: {
      text:
      <span><strong>Assess team performance </strong>  through user leaderboard metrics and milestones. </span>,
    },
    
  },
}

class ProtectPage extends React.Component {
  render() {
    return (
      <Layout> <SEO title={seodata.protect.title} description={seodata.protect.description} keywords={seodata.protect.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          class="protect"
          image={<HandleImages name={"womanServers"} />}
        />

        <Infographic/>
        <Calendly text={content.calendly.text} inv={true} bgColor={"bright-blue"} />

        <h3>Proudly serving organizations in pursuit of persistent cyber training </h3>
        <ResourcesWrapper>
          <Resource
            image={<HandleImages name={"academic"} />}
            title={content.industries.industry1.title}
            text={content.industries.industry1.text}
            url={content.industries.industry1.url}
          />
          <Resource
            image={<HandleImages name={"enterprise"} />}
            title={content.industries.industry2.title}
            text={content.industries.industry2.text}
            url={content.industries.industry2.url}
          />
          <Resource
            image={<HandleImages name={"manWomanComputer"} />}
            title={content.industries.industry3.title}
            text={content.industries.industry3.text}
            url={content.industries.industry3.url}
          />
                 <Resource
            image={<HandleImages name={"gov"} />}
            title={content.industries.industry4.title}
            text={content.industries.industry4.text}
            url={content.industries.industry4.url}
          />
        </ResourcesWrapper>

        <CTARow
          title={content.cta1.title}
          text={content.cta1.text}
          cta={content.cta1.cta}
          url={content.cta1.url}
          inv={false}
          bgColor={"deep-blue"}
          image={"document"}
        />
<h3>Additional Resources </h3>
        <ResourcesWrapper title="Proudly serving organizations in pursuit of persistent cyber training ">
          <Resource
            image={<HandleImages name={"gamification"} />}
            title={content.resources.resource1.title}
            text={content.resources.resource1.text}
            url={content.resources.resource1.url}
          />
          <Resource
            image={<HandleImages name={"aresTVDemo"} />}
            title={content.resources.resource2.title}
            text={content.resources.resource2.text}
            url={content.resources.resource2.url}
          />
          <Resource
            image={<HandleImages name={"manLaptop"} />}
            title={content.resources.resource3.title}
            text={content.resources.resource3.text}
            url={content.resources.resource3.url}
          />
        </ResourcesWrapper>

        <SimpleSlider>
          <SimpleSlide
            image={<HandleImages name={"pAScreen1"} />}
            text={content.simple.simple1.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen2"} />}
            text={content.simple.simple2.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen3"} />}
            text={content.simple.simple3.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen7"} />}
            text={content.simple.simple4.text}
          />
         
        </SimpleSlider>
        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
         
          bgColor={"bright-blue"}
          image={"laptop"}
        />

      </Layout>
    )
  }
}

export default ProtectPage
